import { render, staticRenderFns } from "./PhoneAudio.vue?vue&type=template&id=2690d9fb&scoped=true&lang=pug&"
import script from "./PhoneAudio.vue?vue&type=script&lang=js&"
export * from "./PhoneAudio.vue?vue&type=script&lang=js&"
import style0 from "./PhoneAudio.vue?vue&type=style&index=0&id=2690d9fb&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2690d9fb",
  null
  
)

export default component.exports